import { useEffect } from 'react'

interface Props {
  text: string
  setError: () => void
  autoClose?: number
}

function ErrorMessage({ text, setError, autoClose }: Props) {
  useEffect(() => {
    if (autoClose) {
      const timeout = setTimeout(() => {
        setError()
      }, autoClose)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [autoClose, setError])

  return (
    <div className="error">
      <div className="error__icon">
        <i className="fa-solid fa-circle-exclamation" />
      </div>
      <div className="error__title">{text}</div>
      <div className="error__close" onClick={setError}>
        <i className="fa-solid fa-xmark" />
      </div>
    </div>
  )
}
export default ErrorMessage
